/*jshint esversion: 6 */
import { inject, bindable } from "aurelia-framework";
import { Router, Redirect } from "aurelia-router";
import { AuthService } from "../../services/authService";
import { AccountAPI } from "../../services/accountAPI";
import { UserMessageService } from "../../services/userMessageService";
import moment from "moment";
import fbq from "../../resources/facebook-pixel";
import $ from "jquery";

@inject(AuthService, Router, AccountAPI, UserMessageService)
export class Signup {
  constructor(authService, router, accountApi, userMessageService) {
    this.authService = authService;
    this.router = router;
    this.accountApi = accountApi;
    this.userMessageService = userMessageService;
    this.signupComplete = false;
    this.home_url_new = window.location.origin;
    this.home_url = window.home_url;
    this.privacy_url = this.home_url_new + "/#/visitor/privacypolicy";
    this.tos_url = this.home_url_new + "/#/visitor/termsandcondition";
    this.app_name = "Magnfi";
    this.enable_plus = true;
    this.paymentToken = null;
    this.currencyCode = "";
    this.currencySign = "$";
    this.url = window.location.origin;
    this.url = this.url.replace(/(^\w+:|^)\/\//, "");
    this.gReCaptchaResponse = "";
    this.paymentToken = null;
    this.recaptcha_site_key = "d";
    this.accountApi.getCurrencyCode(
      this.url,
      this.saveLoadSuccess.bind(this),
      this.saveLoadError.bind(this)
    );

    if (window.whitelabel) {
      this.whitelabel = window.whitelabel;

      //this.privacy_url = window.privacy_url;
      //this.tos_url = window.tos_url;
      this.app_name = window.app_name;
      this.enable_plus = window.enable_plus;
    }
    this.clearForm();
    if (this.enable_plus) {
      if (window.whitelabel) this.subscription = "PLUS";
      else this.subscription = "PLUSYEARLY";
    } else this.subscription = "";

    if (!window.whitelabel) this.planElement = null;
    this.saving = false;
    this.step = 1;
  }

  saveLoadSuccess(data) {
    console.log(data);
    this.currencyCode = data;

    if (this.currencyCode == "gbp") this.currencySign = "\u00A3";
  }

  saveLoadError(msg) {}

  canActivate(params) {
    let referralId = params.referralId;
    let direct = params.direct;
    if (referralId && !direct) {
      // When someone comes in following an affiliate link, stash the referral Id in a cookie and send them to the marketing site.
      // We'll pick up the cookie later on when they come back to finish signing up.

      document.cookie = `referralId=${referralId}; expires=${moment(new Date())
        .add(1, "years")
        .utc()
        .format("YYYY-MM-DD HH:mm")}`;

      return new Redirect(window.home_url);
    }

    return true;
  }

  activate(params) {
    let referralId = params.referralId;
    if (referralId) {
      this.referred_by = referralId;
    } else {
      // See if it's in the cookie
      let match = document.cookie.match(new RegExp("(^| )referralId=([^;]+)"));
      this.referred_by = match ? match[2] : null;
    }
    this.step = 1;
  }

  attached() {
    this.accountApi.getRegistrationParams(
      this.registrationParamsSuccess.bind(this),
      this.signupError.bind(this)
    );
  }

  completeStep(step) {
    switch(step) {
      case 1:
        if (this.validate()) {
          this.accountApi.validateEmail(
            this.email,
            () => {
              // if(this.enable_plus){
                this.step = 2;
                $($("footer")[1]).find('article:first').hide()

              // }
              // else
                // this.submit();

            },
            this.signupError.bind(this)
          );
        }
        break;
      case 2:
        this.step = 3;
        $($("footer")[1]).find("article:first").show();

        break;
    }
  }

  onVerified(response) {
    this.gReCaptchaResponse = response;
  }

  submit() {
    if (this.validate()) {
      if (this.gReCaptchaResponse == "") {
        this.signupError("Please resolve the captcha");
        return;
      }

      this.saving = true;

      if (
        (this.subscription == "PLUS" ||
          this.subscription == "PLUSYEARLY" ||
          this.subscription == "PLUSTRIAL") &&
        !this.whitelabel
      ) {
        this.processCardPayment();
      } else if (this.subscription == "PREMIUM" && !this.whitelabel) {
        this.processCardPayment();
      } else {
        this.accountApi.create(
          this.getData(),
          this.signupSuccess.bind(this),
          this.signupError.bind(this)
        );
      }

      // if (this.subscription == "PLUS") {
      //   this.stripe.createToken(this.card, { name: this.cardholderName }).then(function (result) {
      //     if (result.error) {
      //       // Inform the user if there was an error

      //       this.displayError.textContent = result.error.message;
      //     } else {
      //       // Send the token to your server
      //       var data = this.getData();
      //       data.payment_token = result.token.id;
      //       this.accountApi.create(data, this.signupSuccess.bind(this), this.signupError.bind(this));
      //     }
      //   }.bind(this));
      // } else {
      //   this.accountApi.create(this.getData(), this.signupSuccess.bind(this), this.signupError.bind(this));
      // }
    }
  }

  processCardPayment() {
    this.stripe.createToken(this.card, { name: this.cardholderName }).then(
      function (result) {
        if (result.error) {
          this.signupError(result.error.message);
        } else {
          this.paymentToken = result.token.id;
          this.accountApi.create(
            this.getData(),
            this.signupSuccess.bind(this),
            this.signupError.bind(this)
          );
        }
      }.bind(this)
    );
  }

  registrationParamsSuccess(
    key,
    plus_fee,
    plus_yearly_fee,
    premium_fee,
    recaptcha_site_key
  ) {
    this.key = key;
    this.plus_fee = plus_fee;
    this.premium_fee = premium_fee;
    this.plus_yearly_fee = plus_yearly_fee;
    this.recaptcha_site_key = recaptcha_site_key;
    this.apiKeySuccess(key);
    // this.api.getPublicApiKey(this.authService.getUser().token, this.apiKeySuccess.bind(this), this.apiError.bind(this));
  }

  apiKeySuccess(key) {
    this.renderStripe(key);
    // this.api.getPaymentData(this.authService.getUser().token, this.apiPaymentDataSuccess.bind(this), this.apiError.bind(this));
  }

  signupSuccess(user, account, is_trial_expired, sub_error) {
    this.signupComplete = true;
    this.saving = false;
    this.clearForm();

    // We consider the referral cookie to be "used up" now, so clear it by expiring it in the past.
    document.cookie = `referralId=; expires=${moment(new Date())
      .add(-1, "days")
      .utc()
      .format("YYYY-MM-DD HH:mm")}`;

    fbq("track", "CompleteRegistration");
    //window.ga('send', 'event', 'conversion', 'conversion');

    // this.authService.setSubError(sub_error);
    this.authService.loginSuccess(user, account, is_trial_expired);
  }

  signupError(msg) {
    this.saving = false;
    this.userMessageService.setUserError("signup", msg);
  }

  getCookie(name) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");

    if (parts.length == 2) {
      return parts.pop().split(";").shift();
    }
  }

  getData() {
    var data = {
      email: this.email,
      first_name: this.firstName,
      last_name: this.lastName,
      password: this.password1,
      referred_by: this.referred_by,
      subscription: this.subscription,
      payment_token: this.paymentToken,
      g_recaptcha_response: this.gReCaptchaResponse,
    };

    if (this.getCookie("_fprom_ref") && this.getCookie("_fprom_tid")) {
      data.fp_prom_id = this.getCookie("_fprom_ref");
      data.fp_camp_id = this.getCookie("_fprom_tid");
    }

    return data;
  }

  clearForm() {
    this.email = null;
    this.email2 = null;
    this.firstName = null;
    this.lastName = null;
    this.password1 = null;
    this.password2 = null;
    this.subscription = null;
  }

  validate() {
    var pass = true;

    if (this.email === null || this.email.trim() == "") {
      this.userMessageService.setUserError("signup", "Email is empty");
      pass = false;
    }

    if (this.email2 === null || this.email2.trim() == "") {
      this.userMessageService.setUserError(
        "signup",
        "Please confirm email address"
      );
      pass = false;
    }
    if (!this.is_email(this.email)) {
      this.userMessageService.setUserError(
        "signup",
        "Email is not a valid email address"
      );
      pass = false;
    }

    if (this.email != this.email2) {
      this.userMessageService.setUserError(
        "signup",
        "Email addresses do not match"
      );
      pass = false;
    }

    if (this.firstName === null || this.firstName.trim() == "") {
      this.userMessageService.setUserError("signup", "First name is empty");
      pass = false;
    }

    if (this.lastName === null || this.lastName.trim() == "") {
      this.userMessageService.setUserError("signup", "Last name is empty");
      pass = false;
    }

    if (
      this.password1 === null ||
      this.password1.trim() == "" ||
      this.password2 === null ||
      this.password2.trim() == ""
    ) {
      this.userMessageService.setUserError("signup", "Password is empty");
      pass = false;
    }

    if (this.password1 != this.password2) {
      this.userMessageService.setUserError("signup", "Passwords do not match");
      pass = false;
    }

    return pass;
  }

  is_email(email) {
    var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailReg.test(email);
  }

  apiKeySuccess(key) {
    this.renderStripe(key);
  }

  renderStripe(key) {
    // Create a Stripe client
    this.stripe = Stripe(key);

    // Create an instance of Elements
    this.elements = this.stripe.elements();

    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    var style = {
      base: {
        color: "#32325d",
        lineHeight: "24px",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    };

    // Create an instance of the card Element
    this.card = this.elements.create("card" /*, { style: style }*/);

    // Add an instance of the card Element into the `card-element` <div>
    this.card.mount("#card-element");

    // Handle real-time validation errors from the card Element.
    this.card.addEventListener(
      "change",
      function (event) {
        if (event.error) {
          this.displayError.textContent = event.error.message;
        } else {
          this.displayError.textContent = "";
        }
      }.bind(this)
    );
  }
}
